import { useLocation, Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { fetchUserData } from 'redux/login/thunks'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { isDev } from 'utils/env'
import { GTM } from 'utils/gtm'
import { DATA_LAYER_EVENT } from 'constants/dataLayerEvents'
import { supplierIdSelector } from 'redux/common/selectors'
import { authIsLoadedSelector } from 'redux/login/selectors'
import { MENU_PATHS } from 'layouts/MainLayout/Menu/constants'
import { cookiesService, SESSION_COOKIE } from 'utils/cookiesService'
import './styles.module.scss'

export const App = () => {
  const dispatch = useAppDispatch()
  const supplierCompanyId = useAppSelector(supplierIdSelector)
  const isLoaded = useAppSelector(authIsLoadedSelector)
  const { pathname } = useLocation()

  useEffect(() => {
    dispatch(fetchUserData())
  }, [])

  useEffect(() => {
    if (!isDev) {
      GTM.initialize()
    }
  }, [])

  useEffect(() => {
    if (isLoaded) {
      if (supplierCompanyId) {
        const currentMenuItem = Object.keys(MENU_PATHS).find((key) =>
          pathname.includes(MENU_PATHS[key])
        )
        const dataLayerData: { [key: string]: string } = {
          event: DATA_LAYER_EVENT.PAGE_VIEW,
          user_id: String(supplierCompanyId),
          page_location: window.location.href,
        }
        if (cookiesService.get('page_referrer')) {
          dataLayerData.page_referrer = cookiesService.get('page_referrer')
        }
        if (currentMenuItem) {
          dataLayerData.pageTitle = currentMenuItem
        }
        cookiesService.set(
          'page_referrer',
          window.location.href,
          SESSION_COOKIE
        )
        GTM.dataLayer(dataLayerData)
      }
    }
  }, [supplierCompanyId, isLoaded, pathname])

  return <Outlet />
}
